import { render, staticRenderFns } from "./noviceGuide.vue?vue&type=template&id=626b13f5&scoped=true&"
import script from "./noviceGuide.vue?vue&type=script&lang=js&"
export * from "./noviceGuide.vue?vue&type=script&lang=js&"
import style0 from "./noviceGuide.vue?vue&type=style&index=0&id=626b13f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b13f5",
  null
  
)

export default component.exports